import React, { useEffect, useState, useRef } from 'react';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useNavigate } from 'react-router-dom';
import { getAssets } from '../../Services/AssetService';
import { getMenus } from '../../Services/MenuService';
import { setSearchValue } from '../../Stores/Action/AppAction';
import { getLogAssets } from '../../Services/LogService';
import { no_image } from '../../Images';
import { useDispatch } from 'react-redux';
import { formatDateString } from '../../Utils/Utils';

const HomePage = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [category, setCategory] = useState('');
  const [search, setSearch] = useState('');

  const [state, setState] = useState({
    categories: [], //Carousel Categories 
    favid: [0, 0, 0, 0, 0, 0, 0, 0, 0], //Favorite Images 
    favimages: ['', '', '', '', '', '', '', '', ''], //Favorite Images 
    favtitles: ['', '', '', '', '', '', '', '', ''], //Favorite Images 
    favdate: ['', '', '', '', '', '', '', '', ''], //Favorite Images 
    favvideosa: ['', '', ''], //Favorite Video 
    favvideosb: ['', '', ''], //Favorite Video 
    vid_a: [0, 0, 0], //Favorite Video 
    vid_b: [0, 0, 0], //Favorite Video 
    mdownloads: [], //Carousel Most Download Asset
    msearchs: [], //Carousel Most Search Asset
    recndownloads: [], //Carousel Recently Download Asset
  });

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 4
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2
    }
  };

  const responsiveVideos = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 3
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  const onAssetClick = id => () => {
    navigate('/asset/detail/' + id);
  }

  const onExploreClick = (param) => {
    setSearch(param);
    dispatch(setSearchValue(param));
    navigate('/asset/search');
  }

  const setDateFormat = param => {
    let date = '';
    date = param === undefined ? '' : formatDateString(param);
    return date;
  }

  useEffect(() => {
    const requests = [
      //getCategories({ perpage: 10, order: `sort`, direction: `asc`, filter: 'is_active:true' }).then(res => res.data.data), //category
      getMenus({ perpage: 10, order: `sort`, direction: `asc`, filter: 'is_active:true,menu_level:2' }).then(res => res.data.data), //category
      getAssets({ page: 1, perpage: 9, order: `created_on`, direction: `desc`, filter: 'type._id:1,status:Publish,is_active:true', select: `title,thumbnail,created_on` }).then(res => res.data.data), //images
      getAssets({ perpage: 10, order: `created_on`, direction: `desc`, filter: 'type._id:3,status:Publish,is_active:true', select: `title,thumbnail,created_on` }).then(res => res.data.data), //video
      getAssets({ page: 1, perpage: 10, order: `most_download`, direction: `desc`, filter: 'status:Publish,is_active:true', select: `title,thumbnail,created_on` }).then(res => res.data.data), //most download
      getAssets({ page: 1, perpage: 10, order: `most_view`, direction: `desc`, filter: 'status:Publish,is_active:true', select: `title,thumbnail,created_on` }).then(res => res.data.data), //most search
      getLogAssets({ page: 1, perpage: 10, order: `created_on`, direction: `desc`, filter: 'log_type:Download' }).then(res => res.data.data), //recenly download
    ];
    Promise.all(requests).then(results => {
      const [_categories, _images, _videos, _mdownloads, _msearchs, _rdownloads] = results;

      _images.map((item, i) => (
        favimages[i] = item.thumbnail.preview_url != '' ? item.thumbnail.preview_url : no_image,
        favtitles[i] = item.title,
        favdate[i] = formatDateString(item.created_on),
        favid[i] = item._id
      ));

      let videoa = [];
      let videob = [];
      let va = [];
      let vb = [];
      _videos.map((item, i) => {
        if (i < 3) {
          videoa[i] = item.thumbnail.preview_url != '' ? item.thumbnail.preview_url : no_image;
          va[i] = item._id;
        } else {
          videob[i] = item.thumbnail.preview_url != '' ? item.thumbnail.preview_url : no_image;
          vb[i] = item._id;
        }
      });


      setState({
        ...state,
        categories: _categories,
        favid: favid,
        favimages: favimages,
        favtitles: favtitles,
        favdate: favdate,
        favvideosa: videoa,
        favvideosb: videob,
        mdownloads: _mdownloads,
        msearchs: _msearchs,
        recndownloads: _rdownloads,
        vid_a: va,
        vid_b: vb
      });


    });


  }, []);

  const { categories, favid, favimages, favtitles, favdate, favvideosa, favvideosb, mdownloads, msearchs, recndownloads, vid_a, vid_b } = state;

  return (
    <div className='container'>
      <div className='title-large'>
        <span className='text-orange'>Explore</span> Categories on Modena Digital Assets
      </div>
      <div className='caraousel-wrap-1'>
        <Carousel responsive={responsive} draggable={true} keyBoardControl={true} removeArrowOnDeviceType={["tablet", "mobile"]} transitionDuration={500} infinite>
          {
            categories.map((item, i) => (
              <div key={i.toString()} className='caraousel-wrap-1-item'>
                <div className='caraousel-wrap-1-item-grid'>
                  <img src={process.env.REACT_APP_OBS_URL + item.menu_avatar} onClick={() => onExploreClick(item.menu_name)} />
                  {/* <div className='caraousel-wrap-1-item-grid-title'>{item.menu_name}</div> */}
                </div>
              </div>
            ))

          }
        </Carousel>
      </div>
      <div className='caraousel-wrap-2 webview_format'>
        <div className='title-wrap-2'>
          <span >Choose your favorite images</span>
          <button className='btn btn-outline-dark btn' onClick={() => onExploreClick('Favorite images')} >Explore</button>
        </div>

        {/* Image List */}
        <div style={{ marginTop: 40 }}>
          <div style={{ display: 'flex', }}>
            <div className='card-grid-big' onClick={onAssetClick(favid[0])}>
              <img src={favimages[0] != '' ? process.env.REACT_APP_OBS_URL + favimages[0] : no_image} alt="" />
              <div className='wrap-card-overlay'>
                <div className='wrap-card-text'>
                  <div className='card-text-title-16'>{favtitles[0]}</div>
                  <div className='card-text-title-12'>{favdate[0]}</div>
                </div>
              </div>
            </div>
            <div className='wrap-card-grid-right-big'>
              <div className='wrap-card-grid-right-small'>
                <div style={{ marginRight: 3 }} className='wrap-card-grid-small' onClick={onAssetClick(favid[1])}>
                  <img src={favimages[1] != '' ? process.env.REACT_APP_OBS_URL + favimages[1] : no_image} alt="" />
                  <div className='wrap-card-overlay'>
                    <div className='wrap-card-text'>
                      <div className='card-text-title-14'>{favtitles[1]}</div>
                      <div className='card-text-title-10'>{favdate[1]}</div>
                    </div>
                  </div>
                </div>
                <div style={{ marginLeft: 3 }} className='wrap-card-grid-small' onClick={onAssetClick(favid[2])}>
                  <img src={favimages[2] != '' ? process.env.REACT_APP_OBS_URL + favimages[2] : no_image} alt="" />
                  <div className='wrap-card-overlay'>
                    <div className='wrap-card-text'>
                      <div className='card-text-title-14'>{favtitles[2]}</div>
                      <div className='card-text-title-10'>{favdate[2]}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ marginTop: 6 }} className='wrap-card-grid-right-small'>
                <div style={{ marginRight: 3 }} className='wrap-card-grid-small' onClick={onAssetClick(favid[3])}>
                  <img src={favimages[3] != '' ? process.env.REACT_APP_OBS_URL + favimages[3] : no_image} alt="" />
                  <div className='wrap-card-overlay'>
                    <div className='wrap-card-text'>
                      <div className='card-text-title-14'>{favtitles[3]}</div>
                      <div className='card-text-title-10'>{favdate[3]}</div>
                    </div>
                  </div>
                </div>
                <div style={{ marginLeft: 3 }} className='wrap-card-grid-small' onClick={onAssetClick(favid[4])}>
                  <img src={favimages[4] != '' ? process.env.REACT_APP_OBS_URL + favimages[4] : no_image} alt="" />
                  <div className='wrap-card-overlay'>
                    <div className='wrap-card-text'>
                      <div className='card-text-title-14'>{favtitles[4]}</div>
                      <div className='card-text-title-10'>{favdate[4]}</div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div style={{ marginTop: 6 }} className='wrap-card-grid-right-small'>
            <div style={{ marginRight: 3 }} className='wrap-card-grid-small' onClick={onAssetClick(favid[5])}>
              <img src={favimages[5] != '' ? process.env.REACT_APP_OBS_URL + favimages[5] : no_image} alt="" />
              <div className='wrap-card-overlay'>
                <div className='wrap-card-text'>
                  <div className='card-text-title-14'>{favtitles[5]}</div>
                  <div className='card-text-title-10'>{favdate[5]}</div>
                </div>
              </div>
            </div>
            <div style={{ marginLeft: 3, marginRight: 3 }} className='wrap-card-grid-small' onClick={onAssetClick(favid[6])}>
              <img src={favimages[6] != '' ? process.env.REACT_APP_OBS_URL + favimages[6] : no_image} alt="" />
              <div className='wrap-card-overlay'>
                <div className='wrap-card-text'>
                  <div className='card-text-title-14'>{favtitles[6]}</div>
                  <div className='card-text-title-10'>{favdate[6]}</div>
                </div>
              </div>
            </div>
            <div style={{ marginRight: 3, marginLeft: 3 }} className='wrap-card-grid-small' onClick={onAssetClick(favid[7])}>
              <img src={favimages[7] != '' ? process.env.REACT_APP_OBS_URL + favimages[7] : no_image} alt="" />
              <div className='wrap-card-overlay'>
                <div className='wrap-card-text'>
                  <div className='card-text-title-14'>{favtitles[7]}</div>
                  <div className='card-text-title-10'>{favdate[7]}</div>
                </div>
              </div>
            </div>
            <div style={{ marginLeft: 3 }} className='wrap-card-grid-small' onClick={onAssetClick(favid[8])}>
              <img src={favimages[8] != '' ? process.env.REACT_APP_OBS_URL + favimages[8] : no_image} alt="" />
              <div className='wrap-card-overlay'>
                <div className='wrap-card-text'>
                  <div className='card-text-title-14'>{favtitles[8]}</div>
                  <div style={{ color: 'white', fontSize: 10, margin: '0 16px', textShadow: `1px 1px 2px black` }}>{favdate[8]}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='caraousel-wrap-2 mobile_format'>
        <div className='title-wrap-2'>
          <span >Choose your favorite images</span>
          <button className='btn btn-outline-dark btn' onClick={() => onExploreClick('Favorite images')} >Explore</button>
        </div>

        {/* Image List */}
        <div style={{ marginTop: 40 }}>
          <div style={{ display: 'flex', }}>
            <div className='card-grid-big' onClick={onAssetClick(favid[0])}>
              <img src={favimages[0] != '' ? process.env.REACT_APP_OBS_URL + favimages[0] : no_image} alt="" />
              <div className='wrap-card-overlay'>
                <div className='wrap-card-text'>
                  <div className='card-text-title-16'>{favtitles[0]}</div>
                  <div className='card-text-title-12'>{favdate[0]}</div>
                </div>
              </div>
            </div>
          </div>

          <div style={{ marginTop: 6 }} className='wrap-card-grid-right-small'>
            <div style={{ marginRight: 3 }} className='wrap-card-grid-small' onClick={onAssetClick(favid[1])}>
              <img src={favimages[1] != '' ? process.env.REACT_APP_OBS_URL + favimages[1] : no_image} alt="" />
              <div className='wrap-card-overlay'>
                <div className='wrap-card-text'>
                  <div className='card-text-title-14'>{favtitles[1]}</div>
                  <div className='card-text-title-10'>{favdate[1]}</div>
                </div>
              </div>
            </div>
            <div style={{ marginLeft: 3, marginRight: 3 }} className='wrap-card-grid-small' onClick={onAssetClick(favid[2])}>
              <img src={favimages[2] != '' ? process.env.REACT_APP_OBS_URL + favimages[2] : no_image} alt="" />
              <div className='wrap-card-overlay'>
                <div className='wrap-card-text'>
                  <div className='card-text-title-14'>{favtitles[2]}</div>
                  <div className='card-text-title-10'>{favdate[2]}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Video List */}
      <div className='video_wrap webview_format'>
        <div style={{}}>
          <div className='video_wrap_title'>
            <span>Chose your favorite videos</span>
            <button className='btn btn-outline-dark btn' type='button' onClick={() => onExploreClick('Favorite videos')} >Explore</button>
          </div>
          <div className='video_wrap_title_small'>
            <span>Get the inspiration you need with these collections carefully selected to boost your project
            </span>
          </div>
        </div>
        <div style={{ marginTop: 40 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            {
              favvideosa.map((item, i) => (
                <div key={i.toString()} className='video_grid_small'>
                  <img src={item != '' ? process.env.REACT_APP_OBS_URL + item : no_image} alt="" />
                  <div className='overlay_video' onClick={onAssetClick(vid_a[i])}>
                    <span className='fa fa-play-circle'></span>
                  </div>
                </div>
              ))

            }
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
            {
              favvideosb.map((item, i) => (
                <div key={i.toString()} className='video_grid_med'>
                  <img src={item != '' ? process.env.REACT_APP_OBS_URL + item : no_image} alt="" />
                  <div className='overlay_video' onClick={onAssetClick(vid_b[i])}>
                    <span className='fa fa-play-circle' style={{ color: '#aaa', fontSize: 64 }}></span>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>

      <div className='video_wrap mobile_format'>
        <div style={{}}>
          <div className='video_wrap_title'>
            <span>Chose your favorite videos</span>
            <button className='btn btn-outline-dark btn' type='button' onClick={() => onExploreClick('Favorite videos')} >Explore</button>
          </div>
          <div className='video_wrap_title_small'>
            <span>Get the inspiration you need with these collections carefully selected to boost your project
            </span>
          </div>
        </div>
        <div style={{ marginTop: 40 }}>

          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ marginTop: 20 }}>
              {
                favvideosb.map((item, i) => (
                  <div key={i.toString()} className='video_grid_med'>
                    <img src={item != '' ? process.env.REACT_APP_OBS_URL + item : no_image} alt="" />
                    <div className='overlay_video' onClick={onAssetClick(vid_b[i])}>
                      <span className='fa fa-play-circle' style={{ color: '#aaa', fontSize: 64 }}></span>
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </div>

      <div className='wrap_slider mt_home'>
        <div style={{}}>
          <div className='title-wrap-2'>
            <span>Most downloaded assets</span>
            <button className='btn btn-outline-dark btn' onClick={() => onExploreClick('Most download')}>Explore</button>
          </div>

          <div className='cstm-carousel' style={{ marginTop: 20 }}>
            <Carousel responsive={responsiveVideos} draggable={true} keyBoardControl={true} removeArrowOnDeviceType={["tablet", "mobile"]} transitionDuration={500} infinite>
              {
                mdownloads?.map((item, i) => (
                  <div key={'md_' + i} className='wrap_slider_grid'>
                    <img src={process.env.REACT_APP_OBS_URL + item.thumbnail.preview_url} onClick={onAssetClick(item._id)} />

                    <div className='wrap-card-overlay-4' onClick={onAssetClick(item._id)}>
                      <div style={{ position: 'absolute', width: '100%', bottom: 20, left: 0 }}>
                        <div className='card-text-title-14 card-text-overflow-14'>{item.title}</div>
                        <div className='card-text-title-10'>{setDateFormat(item.created_on)}</div>
                      </div>
                    </div>
                  </div>
                ))

              }
            </Carousel>
          </div>
        </div>
      </div>

      <div className='wrap_slider mt_home'>
        <div style={{}}>
          <div className='title-wrap-2 '>
            <span>Most searched assets</span>
            <button className='btn btn-outline-dark btn' onClick={() => onExploreClick('Most search')} >Explore</button>
          </div>

          <div className='cstm-carousel' style={{ marginTop: 20 }}>
            <Carousel responsive={responsiveVideos} draggable={true} keyBoardControl={true} removeArrowOnDeviceType={["tablet", "mobile"]} transitionDuration={500} infinite>
              {
                msearchs?.map((item, i) => (
                  <div key={'ms_' + i} className='wrap_slider_grid'>
                    <img src={process.env.REACT_APP_OBS_URL + item.thumbnail.preview_url} onClick={onAssetClick(item._id)} />
                    <div className='wrap-card-overlay-4' onClick={onAssetClick(item._id)}>
                      <div style={{ position: 'absolute', width: '100%', bottom: 20, left: 0 }}>
                        <div className='card-text-title-14 card-text-overflow-14'>{item.title}</div>
                        <div className='card-text-title-10'>{setDateFormat(item.created_on)}</div>
                      </div>
                    </div>
                  </div>
                ))

              }
            </Carousel>
          </div>
        </div>
      </div>

      <div className='wrap_slider mt_home'>
        <div style={{}}>
          <div className='title-wrap-2'>
            <span>Recently downloaded assets</span>
            <button className='btn btn-outline-dark btn' onClick={() => onExploreClick('Recently download')}>Explore</button>
          </div>

          <div className='cstm-carousel' style={{ marginTop: 20 }}>
            <Carousel responsive={responsiveVideos} draggable={true} keyBoardControl={true} removeArrowOnDeviceType={["tablet", "mobile"]} transitionDuration={500} infinite>
              {
                recndownloads?.map((item, i) => (
                  <div key={'rec_' + i} className='wrap_slider_grid'>
                    <img src={item.asset_url != '' ? process.env.REACT_APP_OBS_URL + item.asset_url : ''} onClick={onAssetClick(item.asset_id)} />
                    <div className='wrap-card-overlay-4' onClick={onAssetClick(item.asset_id)}>
                      <div style={{ position: 'absolute', width: '100%', bottom: 20, left: 0 }}>
                        <div className='card-text-title-14 card-text-overflow-14'>{item.title}</div>
                        <div className='card-text-title-10'>{setDateFormat(item.created_on)}</div>
                      </div>
                    </div>
                  </div>
                ))

              }
            </Carousel>
          </div>
        </div>
      </div>


    </div>
  )
}

const CustomArrow = ({ onClick, ...rest }) => {
  return (<div onClick={() => onClick()} style={{ width: 50, height: 50, background: 'blue' }}>
    <span className='fa fa-chevron-right' style={{ fontSize: 32, color: '#ccc' }}> Right Button</span>
  </div>);
}

export default HomePage;